import React from "react";
import Navbarss from "../navbars/Navbarss";
import { TbTargetArrow } from "react-icons/tb";
import { GrAchievement } from "react-icons/gr";
import { BiTask } from "react-icons/bi";

function Network() {
  return (
    <div>
      <Navbarss />

      {/* Hero Section */}
      <div className="relative w-full">
        <span className="absolute w-full h-full opacity-50 bg-black"></span>
        <img
          src="./image/bak.jpg"
          alt="telebirr"
          className="w-full h-auto object-cover"
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-gray-500 px-4 text-center">
          <h1 className="font-extrabold text-white text-3xl md:text-4xl lg:text-5xl shadow-2xl">
            Digital Business Network
          </h1>
          <p className="p-4 text-white max-w-3xl text-base sm:text-lg md:text-xl lg:text-2xl">
            This program focuses on creating a digital business network for
            Orthodox youth by building an active online database to connect
            individuals and institutions.
          </p>
        </div>
      </div>

      {/* Challenge Section */}
      <section className="text-center py-12">
        <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl text-blue-400">
          Challenge
        </h1>
        <div className="max-w-screen-md mx-auto mt-6 px-4">
          <p className="text-md text-gray-900">
            Finding work is difficult, especially in Ethiopia. The unequal
            distribution of national wealth makes employment a matter of
            fortune. Many youth turn to gambling, addiction, and corruption due
            to the lack of opportunities.
          </p>
          <p className="mt-4">
            At the same time, many organizations struggle to find qualified
            candidates. The best way to bridge this gap is through digital
            business networks.
          </p>
        </div>
      </section>

      {/* Support Section */}
      <section className="flex justify-center mt-6">
        <p className="max-w-2xl text-2xl font-extrabold text-center">
          <a href="/join" className="text-blue-400">
            Support Our Project
          </a>
        </p>
      </section>

      {/* Cards Section */}
      <section className="container mx-auto px-4 py-8">
        <div className="flex flex-wrap justify-center gap-6">
          {/* Card 1 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transform transition-all duration-500 p-6 text-center">
              <div className="text-white p-3 inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                <BiTask className="w-8 h-8" />
              </div>
              <h6 className="text-xl font-semibold">What we do</h6>
              <p className="mt-2 text-gray-700">
                We create a database connecting talented Orthodox youth with
                employers, reducing financial and time expenses while ensuring
                companies acquire moral and qualified workers.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transform transition-all duration-500 p-6 text-center">
              <div className="text-white p-3 inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                <GrAchievement className="w-8 h-8" />
              </div>
              <h6 className="text-xl font-semibold">Achievement</h6>
              <p className="mt-2 text-gray-700">
                We have successfully connected 150 competent and moral young
                professionals with their appropriate employers in recent months.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transform transition-all duration-500 p-6 text-center">
              <div className="text-white p-3 inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                <TbTargetArrow className="w-8 h-8" />
              </div>
              <h6 className="text-xl font-semibold">2025/26 Target</h6>
              <p className="mt-2 text-gray-700">
                Through our digital business network, we aim to connect 2,170
                youth with potential employers in the coming year.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Network;
